import { ChevronDown, Search } from "lucide-react";
import { useMemo, useState } from "react";

export default function SearchableSelect({
  value,
  onChange,
  options,
  placeholder = "Select",
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    return options.filter((item) =>
      item.toLowerCase().includes(search.toLowerCase()),
    );
  }, [options, search]);

  return (
    <div className="relative w-full">
      {/* SELECT BUTTON */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full h-11 sm:h-12 rounded-lg border border-gray-300 bg-white px-3 sm:px-4 flex items-center justify-between text-sm"
      >
        <span className={value ? "text-gray-700" : "text-gray-400"}>
          {value || placeholder}
        </span>

        <ChevronDown
          size={18}
          className={`transition ${open ? "rotate-180" : ""}`}
        />
      </button>

      {/* DROPDOWN */}
      {open && (
        <div className="absolute z-50 mt-2 w-full rounded-xl border bg-white shadow-lg">
          {/* SEARCH */}
          <div className="p-2 sm:p-3">
            <div className="flex items-center gap-2 border rounded-lg px-3 h-10 sm:h-11">
              <Search size={16} className="text-gray-500" />
              <input
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full text-sm outline-none"
              />
            </div>
          </div>

          {/* OPTIONS */}
          <div className="max-h-60 overflow-y-auto pb-2">
            {filtered.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => {
                  onChange(item);
                  setOpen(false);
                  setSearch("");
                }}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
